export const getProp = (prop, fallback) =>
  typeof prop === "string" ? prop : fallback;